import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FaMapMarkerAlt, FaFacebookSquare, FaLinkedin, FaInstagramSquare, FaYoutubeSquare, FaTwitterSquare } from "react-icons/fa"
import footerLogo from '../../../Assets/landing-page/headerfooter/footer-logo-white-pink.png'
import googlepayBadge from '../../../Assets/landing-page/headerfooter/google-play-badge.png'
import footerQrcode from '../../../Assets/landing-page/headerfooter/kidex-playstore-qr-code-new1.png'
import { subscribeNewsletter } from '../../../redux/actions/common';
import "./footer.css";
import { WEB_URL } from '../../../redux/actions/config';
const msgStyle = {
  color: '#FF9FF6',
  fontWeight: 'bold',
  fontStyle: 'italic',
  paddingTop: '50px'
}

const Footer = () => {

  const dispatch = useDispatch();

  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [deviceType, setDeviceType] = useState("");

  useEffect(() => {
    let hasTouchScreen = false;
    if ("maxTouchPoints" in navigator) {
      hasTouchScreen = navigator.maxTouchPoints > 0;
    } else if ("msMaxTouchPoints" in navigator) {
      hasTouchScreen = navigator.msMaxTouchPoints > 0;
    } else {
      const mQ = window.matchMedia && matchMedia("(pointer:coarse)");
      if (mQ && mQ.media === "(pointer:coarse)") {
        hasTouchScreen = !!mQ.matches;
      } else if ("orientation" in window) {
        hasTouchScreen = true; // deprecated, but good fallback
      } else {
        // Only as a last resort, fall back to user agent sniffing
        var UA = navigator.userAgent;
        hasTouchScreen =
          /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
          /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
      }
    }
    if (hasTouchScreen) {
      setDeviceType("Mobile");
    } else {
      setDeviceType("Desktop");
    }
  }, []);


  const emailChangeHandler = (event) => {
    setEmail(event.target.value);
  };

  const submitHandler = (event) => {
    event.preventDefault();
    const check = email.includes(".");
    const valid = email.includes("@");

    if (email === '' || check === false || valid === false) {
      setSuccess('');
      setError('Please enter valid email id to subscription');

    }
    if (email !== '' && email !== undefined && email.includes(".")) {
      setError('');
      dispatch(subscribeNewsletter({ email: email }, () => {
        setEmail("");
      }));
    }
  }

  return (
    <footer>
      <div className="footerSection">
        <div className="block">
          <div className="domainSection">
            <div className="logo"><img src={footerLogo} alt="Kidex" /></div>
            <div className="content">
              <div className="text">© 2020 by KidEx Venture Pvt. Ltd. <br />Plot 108, Sector 44, Gurgaon, Haryana</div>
              <a href="https://www.google.com/maps?ll=28.452097,77.07253&z=16&t=m&hl=en&gl=IN&mapclient=embed&q=108+Sector+44+Gurugram,+Haryana+122022" target="_blank"><div className="location"><FaMapMarkerAlt style={{ marginBottom: "5px", marginRight: "5px" }} /><u> Locate Us On Google</u></div></a>
            </div>
            <div className="social">
              <a href="https://www.facebook.com/groups/454296315931069" title="Facebook" className="socialBlock" target="_blank"><FaFacebookSquare color="#333" size="2em" /></a>
              <a href="http://linkedin.com/company/kidex" title="linkedin" className="socialBlock" target="_blank"><FaLinkedin color="#333" size="2em" /></a>
              <a href="https://www.instagram.com/kidexindia/" title="instagram" className="socialBlock" target="_blank"><FaInstagramSquare color="#333" size="2em" /></a>
              <a href="https://www.youtube.com/channel/UCgRthBo8eHcpkHLLuk76Q6g" title="youtube" className="socialBlock" target="_blank"><FaYoutubeSquare color="#333" size="2em" /></a>
              <a href="https://twitter.com/KidExIndia" title="twitter" className="socialBlock" target="_blank"><FaTwitterSquare color="#333" size="2em" /></a>
            </div>
          </div>
        </div>
        <div className="block ">

          <div className="links ">
            <ul>
              <li><a href={`${WEB_URL}/about-us`} target="_blank">About Us</a></li>
              <li><a href={`${WEB_URL}/join-us`} target="_blank">Work with us</a></li>
              <li><a href={`${WEB_URL}/contact-us`} target="_blank">Contact Us</a></li>
              <li><a href={`${WEB_URL}/request-support`} target="_blank">Request support</a></li>
              <li><a href={`${WEB_URL}/champions/share-activities`} target="_blank">Contribute ideas</a></li>
              <li><a href={`${WEB_URL}/invite-others`} target="_blank">Invite others</a></li>
              <li><a href={`${WEB_URL}/write-testimonial`} target="_blank">Share testimonials</a></li>
              <li><a href={`${WEB_URL}/class/refund`} target="_blank">Request refund</a></li>
            </ul>
          </div>
        </div>
        <div className="block">
          <div className="links">
            <div className="title"><a href={`${WEB_URL}/media-coverage`} target="_blank">Media coverage</a></div>
            <div className="media">
              <div className="video">
                <iframe src="https://www.youtube.com/embed/Z33dIbXA0ac" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              </div>
              <div class="youtube-link"> <a href="https://www.youtube.com/watch?v=Z33dIbXA0ac" target="_blank" style={{ color: '#c00096' }}>View on youtube</a></div>
            </div>
          </div>
        </div>
        <div className="block">
          <div className="subscribe">
            <div className="title">Subscribe to Our ­Newsletter</div>
            <form onSubmit={submitHandler}>
              <div className="form" >
                <input type="text" name="email" id="email"
                  placeholder="Enter your email id to subscribe"
                  value={email}
                  onChange={emailChangeHandler}
                />
                <div className="msg error" style={msgStyle}>{success}</div>
                <div className="msg error" style={{ color: 'red' }}>{error}</div>
                <button type='submit' >Subscribe</button>
              </div>
            </form>
          </div>
        </div>
        <div className="gplaystore">
          <a target="blank" href="https://play.google.com/store/apps/details?id=com.kidex.app"><div className="playstore-badge"><img src={googlepayBadge} alt="Kidex" /></div></a>
          <div className="qr-code"><img src={footerQrcode} alt="Kidex" /></div>
        </div>
      </div>
      <div className="footerCopy">
        <div className="text"> <span>&copy;</span> 2020 by KidEx Venture Pvt. Ltd.</div>
        <a className="text t-n-c">
          <a href={`${WEB_URL}/tnc`} target="_blank">Terms and Conditions</a> |<a href={`${WEB_URL}/ppc`} target="_blank"> Privacy Policy</a></a>
      </div>
    </footer>
  )
}

export default Footer;
